import "./App.css";
import Login from "./views/Login";
import {useAuth0} from "@auth0/auth0-react";
import {Switch, Route} from "react-router-dom";
import React from "react";
import Callback from "./components/Callback";
import LoadingPage from "./views/LoadingPage";
import LandingAdviser from "./views/adviser/LandingAdviser";
import AdviserRegisterPage from "./components/Formularios/adviserRegister/AdviserRegisterPage";
import AffinityRoutes from "./routes/AffinityRoutes";
import UserRoutes from "./routes/UserRoutes";
import ProtectedRoute from "./components/ProtectedRoute"
import ValidatePassphrasePage from "./components/Formularios/validatePassphrase/ValidatePassphrasePage";
import ProtectedUserRoute from "./components/ProtectedUserRoutes";

function App() {
    const { isLoading } = useAuth0();
    if (isLoading) {
        return <LoadingPage/>;
    }
    return (

        <Switch>
            {/*USUARIOS*/}
            {/*Accepts all users*/}
            <Route path={'/'} exact component={LandingAdviser}/>
            <Route path={'/loading'} exact component={LoadingPage}/>
            <Route exact path="/ingresar" component={Login}/>

            {/*Accepts google logged in users*/}
            <ProtectedRoute exact path={'/callback'} component={Callback}/>
            <ProtectedRoute path={'/validate-passphrase'} component={ValidatePassphrasePage}/>

            {/*Accepts google logged in users with right password (requirePassphrase)*/}
            <ProtectedRoute path={'/form'} component={AdviserRegisterPage} requirePassphrase/>

            {/*Accepts polko logged in users*/}
            <ProtectedUserRoute path="/u" component={UserRoutes}/>

            {/*CLIENTES*/}
            <Route path="/a/:CodigoProductor/:affinityId" component={AffinityRoutes}/>
        </Switch>
    );
}

export default App;
